
import React,{ Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
// javascript plugin used to create scrollbars on windows

// core components
import RTLNavbar from "../components/Navbars/RTLNavbar.js";
import Footer from "../components/Footer/Footer.js";
import Sidebar from "../components/Sidebar/Sidebar.js";

import routes from "../routes.js";
import { BackgroundColorContext } from "../contexts/BackgroundColorContext";
import { apiCall } from '../Service/ConnectToServer.js';
import Swal from 'sweetalert2'
import Loading from '../Helper/Loading.js'
import Particles from "../components/Particle";
class RTL extends Component {

    constructor(props) {
        super(props);
        this.state={
            IsLoading:true,
            siteSetting:{},
            sidebarOpened:document.documentElement.className.indexOf("nav-open") !== -1
        }
        this.mainPanelRef= React.createRef();
    }

    componentDidMount(){

        let head = document.head;
        let meta1 = document.createElement("meta");
        let meta2 = document.createElement("meta");
        meta1.name = "description";
        meta2.name = "keywords";

        const config = {
            method: "Post",
            url: "User/GetUserSiteSetting",
            Authorization: true,
            data: {}
        }

        apiCall(config, (response) => {
            const domain = window.location.host.replace(/.+\/\/|www.|\..+/g, '').replace('/','');
            const resultDomain=response.data.Result.Domain.replace(/.+\/\/|www.|\..+/g, '').replace('/','');
            if(resultDomain===domain){
                if(response.data.Result.State===2 || response.data.Result.State===3){
                   this.props.history.push({
                        pathname:"/403",
                        state:{
                            title: 'این سایت از دسترس خارج شده است ',
                            text: 'لطفا با پشتیبانی تماس بگیرید  \n '+response.data.Result.DehyariPhoneNumber
                         }
                       });
                }
                else{
                    this.setState({
                        IsLoading:false
                    })
            if (response.data.Result.SiteHeader == null ||
                response.data.Result.SiteHeader === "") {
                response.data.Result.SiteHeader = "سامانه پرداخت الکترونیکی عوارض"
            }
            this.setState({
                siteSetting:response.data.Result
            })
            meta1.content=response.data.Result.DescriptionMeta;
            meta2.content=response.data.Result.KeywordsMeta;
            head.appendChild(meta1);
            head.appendChild(meta2);
           // manifestDynamic(response.data.Result.DehyariAddress,
              //  response.data.Result.SiteTitle,response.data.Result.HeaderLogoUrl)
        }}
        else{
            this.props.history.push({
                pathname:"/403",
                state:{
                    title: 'عملیات ناموفق',
                    text: 'کد دسترسی به دامنه سایت تعلق ندارد'
                 }
               });
        }
        }, (err) => {
            Swal.fire({
                title: 'عملیات ناموفق',
                text: err,
                icon: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
        });
        this.MetaTagAdd();
    }

   MetaTagAdd=() => {
        // on this page, we need on the body tag the classes .rtl and .menu-on-right
        document.body.classList.add("rtl", "menu-on-right");
        // we also need the rtl bootstrap
        // so we add it dynamically to the head
        let head = document.head;
        let link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.id = "rtl-id";
        link.href=require("../assets/css/Rtl.css").default;
        head.appendChild(link);
        // Specify how to clean 

        document.title = this.getBrandText(window.location.pathname);
        // Specify how to clean up after this effect:
        return function cleanup() {
            // when we exit this page, we need to delete the classes .rtl and .menu-on-right
            // from the body tag
            document.body.classList.remove("rtl", "menu-on-right");
            // we also need to delete the rtl bootstrap, so it does not break the other pages
            // that do not make use of rtl
            document.getElementById("rtl-id").remove();
        };
    };

    // this function opens and closes the sidebar on small devices
 toggleSidebar = () => {
        document.documentElement.classList.toggle("nav-open");
        this.setState({
            sidebarOpened:!this.state.sidebarOpened
        })
    };

 getRoutes = (routes) => {
        return routes.map((prop, key) => {
            return (
                <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                />
                
            );
        });
    };

 getBrandText = (path) => {
        for (let i = 0; i < routes.length; i++) {
          if ( window.location.pathname.indexOf(routes[i].path) !== -1) {
            return  this.state.siteSetting.SiteTitle+" | "+routes[i].rtlName;
          }
        }
        return "سامانه پرداخت الکترونیکی عوارض";
      };
/* const manifestDynamic=(Domain,name,HeaderLogoUrl)=>{
    var myDynamicManifest = {
        "name": name,
        "short_name":Domain,
        "start_url": "http://localhost:48211/Payment",
        "background_color": "#000000",
        "theme_color": "#0f4a73",
        "icons": [{
          "src": HeaderLogoUrl,
          "sizes": "60x60",
          "type": "image/png"
        }]
      }
      const stringManifest = JSON.stringify(myDynamicManifest);
      const blob = new Blob([stringManifest], {type: 'application/json'});
      const manifestURL = URL.createObjectURL(blob);
      document.querySelector('#my-manifest-placeholder').setAttribute('href', manifestURL);
} */

render(){
    const {IsLoading,siteSetting,sidebarOpened}=this.state;
    if (IsLoading) {
        return (
            <>
                <div className="main-panel" ref={this.mainPanelRef}>
                    <Loading />
                </div>
            </>
        )
    }
    else {
        return (
            <>
                <BackgroundColorContext.Consumer>
                    {({ color, changeColor }) => (
                        <>
                            <RTLNavbar
                                siteHeader={siteSetting.SiteHeader}
                                siteTitle={siteSetting.SiteTitle}
                                siteLogoUrl={siteSetting.HeaderLogoUrl}
                                toggleSidebar={this.toggleSidebar}
                                sidebarOpened={sidebarOpened}
                            
                            />

                            <div className="wrapper">
                                <Sidebar
                                    routes={routes}
                                    toggleSidebar={this.toggleSidebar}
                                    Enamad={siteSetting.Enamad}
                                />

                                <div className="main-panel" ref={this.mainPanelRef} data={color}>
                                <Particles />
                                    <Switch>
                                        {this.getRoutes(routes)}
                                        <Redirect from="*" to="/Payment" />
                                    </Switch>

                                    <Footer 
                                    siteSetting={siteSetting}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </BackgroundColorContext.Consumer>
            </>
        );
    }
}

}


export default RTL;
